import moment from 'moment'
const hostname = window.location.hostname;

const isProduction = hostname === 'app.hapsmiths.com';
const isStaging = hostname === 'hpsmithstagefe.six30labs.com';
export const BASE_URL = isProduction ? 'https://admin.hapsmiths.com/' : isStaging ? 'https://hpsmithstagebe.six30labs.com/' : 'https://hpsmithstagebe.six30labs.com/'
//Production Server
//   export const BASE_URL = 'https://admin.hapsmiths.com/'
  export const CHAT_URL = 'https://chat.hapsmiths.com'
export const RAZORPAY_KEY = isProduction
  ? 'rzp_live_RcR0Eyfy5CToJ5'
  : 'rzp_test_nlYlH13408kYk6';
// Local Server
// export const CHAT_URL = 'http://localhost:3001'

// Six30Labs Staging Server
//   export const BASE_URL = 'https://hpsmithstagebe.six30labs.com/'
// chaturl same for both https://chat.hapsmiths.com
 // export const CHAT_URL = 'https://livupchat.six30labs.com'
//  export const GOOGLE_CLIENT_ID = "116648439301-vck048oo5acjt7nba1gb4lc06jm56fub.apps.googleusercontent.com" //staging
export const GOOGLE_CLIENT_ID = '116648439301-vck048oo5acjt7nba1gb4lc06jm56fub.apps.googleusercontent.com' //local google sign in
   

export const currentTime = moment(new Date(), 'h:mm:ss A').format('HH:mm')
export const currentDate = moment(new Date()).format('YYYY-MM-DD')

export const OTP_TIMER = 60
